module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/holiday-exception-list/holiday-exception-list.component.scss
// module id = 1531
// module chunks = 0